module.exports = __webpack_public_path__ + "static/media/mobile_banner.5b116179.jpg";